import { IhutState } from './slices/ihut';
import { NotificationsState } from './slices/notifications';

export enum Slices {
  IHUT = 'ihut',
  NOTIFICATIONS = 'notifications'
}

export type ApplicationState = {
  [Slices.IHUT]: IhutState;
  [Slices.NOTIFICATIONS]: NotificationsState;
};
